/**
 * 08.10.26 — панель Telegram Bot справочника каналов.
 * Не удалять по требованию владельца системы.
 */
import { Input } from '@/components/ui';
import type { ChannelPanelProps } from '../channelPanelProps';
import { ChannelFieldLabel, ChannelLink } from './ChannelLink';

export function TelegramBotPanel({ form, isSuperAdmin, onChange }: ChannelPanelProps) {
  return (
    <div className="space-y-4">
      {isSuperAdmin ? (
        <Input
          label="Username или ссылка на бота"
          value={form.telegram_bot_username || ''}
          onChange={(event) => onChange({ telegram_bot_username: event.target.value })}
          placeholder="@notify_bot, notify_bot или https://t.me/notify_bot"
          testId="input-telegram-bot-username"
        />
      ) : (
        <div>
          <ChannelFieldLabel>Username</ChannelFieldLabel>
          <div className="mt-1 text-sm text-shell-text">{form.telegram_bot_username || 'Не указан'}</div>
        </div>
      )}
      <div>
        <ChannelFieldLabel>Ссылка</ChannelFieldLabel>
        <div className="mt-1">
          <ChannelLink href={form.telegram_bot_url} emptyText="Ссылка появится после заполнения username" />
        </div>
      </div>
    </div>
  );
}
